
const SBMA_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const ROLE_MANAGEMENT_SERVICE_BASE_URL = SBMA_API_ENDPOINT + "/api/v1/management";

export default {

    //ROLE MANAGEMENT SERVICE
    GET_ROLES:                              ROLE_MANAGEMENT_SERVICE_BASE_URL + "/roles",
    CREATE_ROLE:                            ROLE_MANAGEMENT_SERVICE_BASE_URL + "/roles/create",
    UPDATE_ROLE_STATUS:                     ROLE_MANAGEMENT_SERVICE_BASE_URL + "/roles/update/status",
    DELETE_ROLE:                            ROLE_MANAGEMENT_SERVICE_BASE_URL + "/roles/delete",
    UPDATE_ROLE:                            ROLE_MANAGEMENT_SERVICE_BASE_URL + "/roles/update",

    // MODULE
    LIST_MODULE:                              ROLE_MANAGEMENT_SERVICE_BASE_URL + "/modules",
    CREATE_MODULE:                            ROLE_MANAGEMENT_SERVICE_BASE_URL + "/modules/create",
    UPDATE_MODULE:                          ROLE_MANAGEMENT_SERVICE_BASE_URL + "/modules/update",
    DELETE_MODULE:                            ROLE_MANAGEMENT_SERVICE_BASE_URL + "/modules/delete",

    // PERMISSION
    LIST_ALL_PERMISSSIONS:                  ROLE_MANAGEMENT_SERVICE_BASE_URL + "/permissions/all",
    LIST_PERMISSIONS:                       ROLE_MANAGEMENT_SERVICE_BASE_URL + "/permissions",
    CREATE_PERMISSION:                      ROLE_MANAGEMENT_SERVICE_BASE_URL + "/permissions/create",
    UPDATE_PERMISSION:                      ROLE_MANAGEMENT_SERVICE_BASE_URL + "/permissions/update",
    UPDATE_PERMISSION_MODULE:               ROLE_MANAGEMENT_SERVICE_BASE_URL + "/permissions/update/module",
    DELETE_PERMISSION:                      ROLE_MANAGEMENT_SERVICE_BASE_URL + "/permissions/delete",

    // ACCESS CONTROL
    GET_ACC:                                ROLE_MANAGEMENT_SERVICE_BASE_URL + "/acc",
    ADD_ACC:                                ROLE_MANAGEMENT_SERVICE_BASE_URL + "/acc/add",
    REMOVE_ACC:                             ROLE_MANAGEMENT_SERVICE_BASE_URL + "/acc/remove",
}


